import { useQuery } from "@tanstack/react-query";
import { getGoogleBusinessProfile } from "../../api/bReviewsApi";

export const useGetGoogleBusinessProfile = (
  organisationId,
  locationId,
  enabled = true
) => {
  return useQuery({
    queryKey: ["google-business-profile", organisationId, locationId],
    queryFn: () => getGoogleBusinessProfile(organisationId, locationId),
    enabled: !!organisationId && !!locationId && enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
